import { useQuery } from "@tanstack/react-query";
import { getCitizenships, getDefaultCitizenshipCountry } from "./services";

export const useCitizenshipsQuery = () =>
  useQuery({
    queryKey: ["citizenships"],
    queryFn: getCitizenships,
    staleTime: Infinity,
  });

export const useDefaultCitizenshipsCountryQuery = () =>
  useQuery({
    queryKey: ["defaultCitizenshipCountry"],
    queryFn: getDefaultCitizenshipCountry,
    staleTime: Infinity,
  });
